import { render } from "./CartTableProductOrderItem.vue?vue&type=template&id=6166b796"
import script from "./CartTableProductOrderItem.vue?vue&type=script&lang=js"
export * from "./CartTableProductOrderItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__